import { Field } from 'react-final-form';
import React from 'react';
import { TextField, Checkbox } from 'final-form-material-ui';
import { Grid, Paper, InputLabel, FormControlLabel } from '@material-ui/core';
import required from '../validators/required';
import Condition from '../utilities/Condition';

const OrganisationDetails = () => (
  <Paper style={{ padding: 16, marginTop: 16 }}>
    <Grid container alignItems="flex-start" spacing={8}>
      <Grid item xs={12} style={{paddingBottom: 10}}>
        <InputLabel htmlFor="OrganisationName">Organisation Name:</InputLabel>
        <Field
          fullWidth
          required
          name="OrganisationName"
          component={TextField}
          type="text"
          validate={required}
        />
      </Grid>
      <Grid item xs={12} style={{paddingBottom: 20}}>
        <FormControlLabel
          label="Member of the NZACA"
          control={
            <Field
              name="NZACAMember"
              component={Checkbox}
              type="checkbox"
            />
          }
        />
      </Grid>
      <Grid item xs={12} style={{paddingBottom: 20}}>
        <InputLabel htmlFor="Address">Address:</InputLabel>
        <Field
          fullWidth
          required
          name="Address"
          component={TextField}
          type="text"
          validate={required}
        />
      </Grid>
      <Grid item xs={12} style={{paddingBottom: 20}}>
        <InputLabel htmlFor="City">City:</InputLabel>
        <Field
          fullWidth
          required
          name="City"
          component={TextField}
          type="text"
          validate={required}
        />
      </Grid>
      <Grid item xs={12} style={{paddingBottom: 20}}>
        <InputLabel htmlFor="PostCode">Post Code:</InputLabel>
        <Field
          fullWidth
          required
          name="PostCode"
          component={TextField}
          type="text"
          validate={required}
        />
      </Grid>
      <Grid item xs={12} style={{paddingBottom: 20}}>
        <InputLabel htmlFor="Phone">Phone:</InputLabel>
        <Field
          fullWidth
          required
          name="Phone"
          component={TextField}
          type="tel"
          validate={required}
        />
      </Grid>
      <Grid item xs={12} style={{paddingBottom: 20}}>
        <InputLabel htmlFor="Email">Email:</InputLabel>
        <Field
          fullWidth
          required
          name="Email"
          component={TextField}
          type="email"
          validate={required}
        />
      </Grid>
      <Grid item xs={12} style={{paddingBottom: 20}}>
        <FormControlLabel
          label="Add a billing email?"
          control={
            <Field
              name="BillTo"
              component={Checkbox}
              type="checkbox"
            />
          }
        />
      </Grid>
      <Condition when="BillTo" is={true}>
        <InputLabel htmlFor="BillingEmail">Billing Email:</InputLabel>
        <Grid item xs={12} style={{paddingBottom: 20}}>
          <Field
            fullWidth
            required
            name="BillingEmail"
            component={TextField}
            type="email"
            validate={required}
          />
        </Grid>
      </Condition>
    </Grid>
  </Paper>
);

export default OrganisationDetails;
